import React, { ReactNode } from "react";
import { Offcanvas } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Define props interface for the component
interface OverlayDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  placement?: "start" | "end" | "top" | "bottom";
  title: string;
}

const OverlayDrawer: React.FC<OverlayDrawerProps> = ({
  open,
  onClose,
  children,
  placement = "end",
  title,
}) => {
  return (
    <Offcanvas
      show={open}
      onHide={onClose}
      placement={placement}
      style={{
        width: placement === "end" || placement === "start" ? "70%" : "100%",
      }}
    >
      <Offcanvas.Header closeButton>
        {/* Dynamic Title */}
        <Offcanvas.Title>{title}</Offcanvas.Title>

        {/* Cancel Button (close the drawer) */}
        <button
          id="log-overlay-drawer"
          className="btn btn-link"
          style={{
            position: "absolute",
            top: "6px",
            right: "10px",
            fontSize: "16px",
            border: "none",
            background: "none",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <span className="material-icons">close</span>
        </button>
      </Offcanvas.Header>
      <Offcanvas.Body style={{ overflowY: "auto" }}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default OverlayDrawer;
